import { useEffect, useState } from 'react'
import { collection, getDocs, onSnapshot, query, where } from 'firebase/firestore'
import { db } from '../../../../firebase'
import { useNavigate } from 'react-router-dom'
import './freecourses.css'

import Header from '../../Header/Header'

function FreeCourses() {
  const [courses, setCourses] = useState([])
  const navigate = useNavigate()

  const [search, setSearch] = useState('')

  useEffect(() => {
    const fetchCourses = async () => {
      const q = query(collection(db, 'courses'), where('type', '==', 'free'))

      const snapshot = await getDocs(q)
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))

      setCourses(data)
    }

    fetchCourses()
  }, [])

  const filteredCourses = courses.filter(
    (course) =>
      course.title.toLowerCase().includes(search.toLowerCase()) ||
      course.description.toLowerCase().includes(search.toLowerCase())
  )

  useEffect(() => {
    const q = query(collection(db, 'courses'), where('type', '==', 'free'))

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      setCourses(data)
    })

    return () => unsubscribe()
  }, [])

  return (
    <>
      <Header />
      <div>
        <h1>Бесплатные курсы</h1>

        <input
          type="text"
          placeholder="Поиск курсов"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="freecourse-search-input"
        />

        {courses.length === 0 ? (
          <p>Бесплатных курсов пока нет</p>
        ) : (
          <div className="courses-nav-details-container">
            {filteredCourses.map((course) => (
              <button
                className="courses-nav-details"
                key={course.id}
                onClick={() => navigate(`/courses/free/${course.id}`)}
              >
                <h3>{course.title}</h3>
                <p>{course.description}</p>
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default FreeCourses
